import React from 'react';
import TableC from '../../../basicElement/TableC';

function AssignHistory({ data, showEmployeeDetail }) {
    const getColumns = () => {
        const columns = [{
            title: '分派时间',
            dataIndex: 'processTime',
            key: 'processTime',
        }, {
            title: '分派人员',
            dataIndex: 'processUser',
            key: 'processUser',
            render: (text, record) => {
                const { processUser } = record;
                return (
                    <span>
                        {
                            (processUser || []).map((item, index, array) => (
                                <a onClick={() => showEmployeeDetail(item.userId, item.employeeCode, item.userName)} key={item.userId}>
                                    {item.userName}({item.employeeCode}){array.length > 1 ? ';' : ''}
                                </a>
                            ))
                        }
                    </span>
                )
            }
        }, {
            title: '拒绝时间',
            dataIndex: 'refuseTime',
            key: 'refuseTime',
        }, {
            title: '被拒绝原因',
            dataIndex: 'refuseReason',
            key: 'refuseReason',
        }];

        return columns;
    }

    const getDataSource = () => {
        return (data || []).map(i => ({
            processTime: i.relateTime,
            refuseTime: i.createTime,
            refuseReason: i.remark,
            processUser: i.assignmentList,
            id: i.requirementTransactionId,
        }));
    }

    return (
        <TableC
            columns={getColumns()}
            data={getDataSource()}
            className="assignHistory"
            rowKey="id"
        />
    );
}

export default AssignHistory;


// WEBPACK FOOTER //
// ./src/components/user/require/tables/AssignHistory.js